import { Avatar, styled } from "@mui/material";

export const AvatarWrapper = styled(Avatar)`
  width: 0.9rem;
  height: 0.9rem;
  cursor: pointer;
  margintop: 0.1rem;
  marginbottom: 0.1rem;
`;
